import { hcl } from 'd3-color';
import { interpolateHcl } from 'd3-interpolate';

type GradientStop = { stop: number; hex: string };

/**
 * Returns an RGB color string by interpolating through a multi-stop gradient
 * in HCL (perceptually uniform) color space, mapping `value` within [min, max]
 * to the [0, 1] range of the gradient.
 */
export function gradientColor( value: number, min: number, max: number, gradient: GradientStop[] ): string {
  const t = Math.max( 0, Math.min( 1, max > min ? ( value - min ) / ( max - min ) : 0.5 ) );

  for ( let i = 1; i < gradient.length; i++ ) {
    if ( t <= gradient[i].stop ) {
      const localT = ( t - gradient[i - 1].stop ) / ( gradient[i].stop - gradient[i - 1].stop );
      return interpolateHcl( gradient[i - 1].hex, gradient[i].hex )( localT );
    }
  }
  return hcl( gradient[gradient.length - 1].hex ).toString();
}
